import { Environment } from '@/types/environment';
import { EnvConfigShape } from './types';

export const QUALTRICS_SCRIPT_ID = 'qualtrics-script';
export const QUALTRICS_KEY_LOCALSTORAGE = 'qualtrics';
export const QUALTRICS_KEY_METADATA = 'metadata';
export const QUALTRICS_KEY_GENERAL_SURVEY = 'generalSurvey';

const DISABLED_CONFIG: EnvConfigShape = {
  isEnabled: false,
};

export const ENV_CONFIGS: Record<Environment, EnvConfigShape> = {
  staging: {
    qualtricsSnippetPath: 'https://hudl-content.hudl.com/qualtrics/script-thor.js',
    qualtricsSnippetId: 'ZN_0qv9Qr62ZohxCTA',
    isEnabled: true,
  },
  production: {
    qualtricsSnippetPath: 'https://hudl-content.hudl.com/qualtrics/script.js',
    qualtricsSnippetId: 'ZN_3gxvrNeuCxeRi1U',
    isEnabled: true,
  },
  development: DISABLED_CONFIG,
  test: DISABLED_CONFIG,
};
